<template>

	<div class="live-view">
		<div class="header">
			<erco-header :name="objectName"
			             :id="objectId"
			             :processstate="processState"
			             @change="handleActionChange">
			</erco-header>
		</div>

		<div class="frame">
			<erco-cloak v-if="objectIsLoading || isUpdatingStatus"></erco-cloak>
			<div v-if="!objectIsLoading"
			     class="frame-inner">
				<iframe v-if="objectUrl"
				        class="iframe"
				        :src="objectUrl">
				</iframe>
				<div v-else class="not-found-info">
					<b-alert show
					         class="info-text"
					         variant="warning">
						Das Objekt besitzt noch keine URL
					</b-alert>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import url from 'url';

	import ErcoCloak from '@/components/molecules/ErcoCloak';

	import ErcoLiveViewHeader from '@/components/molecules/ErcoLiveViewHeader';

	export default {
		name: 'ErcoLiveViewPage',

		created() {
			const objectId = parseInt(this.$route.params.objectId, 10);
			this.processView = this.$route.params.processview || this.processView;

			this.$store.dispatch('getObjectSetup', { id: objectId, lang: this.lang })
			.then(() => {
				this.$store.dispatch('setAccessErrorStatusCode', -1);
				const title = this.objectDataset[`S_${this.lang}_Objekt`];
				document.title = `${objectId} - ${title}`;
			})
			.catch(() => {
				 /* TODO: Use (better) logging; 'Keine Verbindung zur Ressource:', response */
			});
		},

		data() {
			return {
				lang: 'de',
				processView: '',
				isUpdatingStatus: false,
			};
		},

		computed: {
			objectDataset() {
				return this.$store.state.objectsetup.current;
			},

			objectIsLoading() {
				return this.$store.state.objectsetup.loading;
			},

			objectName() {
				if (!this.objectDataset) {
					return '';
				}

				const lang = this.objectDataset.sprache || this.lang;
				const name = this.objectDataset[`S_${lang}_Objekt`];

				return name;
			},

			objectId() {
				return this.objectDataset.PKM_Objekt || '';
			},

			processState() {
				const processViews = {
					unknown: {
						name: '(unbekannter Modus)',
					},
					redaktionellefreigabe: {
						name: 'Red. Freigabe',
					},
					uebersetzung: {
						name: 'Übersetzung',
					},
					endfreigabe: {
						name: 'End-Freigabe',
					},
					technischefreigabe: {
						name: 'Techn. Freigabe',
					},
					linkspruefen: {
						name: 'Links geprüft',
					},
					fremdsprachenpruefen: {
						name: 'Fremdsprachen geprüft',
					},
				};

				const selectedProcessView =
					(processViews[this.processView] &&
						{ id: this.processView,
						  ...processViews[this.processView],
						  items: this.pkStatusProcessItemsDropdownItems,
						  currentProcessStatusItem: this.currentProcessStatusItem }) ||
					{ id: '', ...processViews.unknown, items: [], currentProcessStatusItem: null };

				return selectedProcessView;
			},

			objectUrl() {
				const serverUrl = process.env.LS2014_SERVER;
				return this.objectDataset.S_URL_Objekt ?
				        url.resolve(serverUrl, this.objectDataset.S_URL_Objekt) :
				        '';
			},

			currentProcessStatusItem() {
				const currentProcessStatusId =
					this.objectDataset[`FKM_PK_Status_${this.processView}`];
				const currentProcessStatusItem =
					this.pkStatusProcessItems
						.find(item => item.PKM_Status === currentProcessStatusId);

				return currentProcessStatusItem;
			},

			pkStatusProcessItems() {
				if (!this.objectDataset.pk_status) {
					return [];
				}

				const pkStatusProcessItemGroups = this.objectDataset.pk_status.reduce((data, item) => {
					if (!data[item.S_Modus]) {
						data[item.S_Modus] = [];
					}

					data[item.S_Modus].push(item);
					return data;
				},
				{});

				return pkStatusProcessItemGroups[this.processView];
			},

			pkStatusProcessItemsDropdownItems() {
				const ret = this.pkStatusProcessItems.map(item => ({
					value: item.PKM_Status,
					text: item.S_Status_Aktion,
				}));

				return ret;
			},
		},

		methods: {
			handleActionChange(key) {
				const item = this.pkStatusProcessItems.find(currItem => currItem.PKM_Status === key);

				if (!item) {
					return;
				}

				this.isUpdatingStatus = true;

				this.$store.dispatch('updateObjectSetupPkStatus', item).then((data) => {
					this.isUpdatingStatus = false;

					if (item.B_Mailclient === 'j') {
						const body = encodeURIComponent(data.body.replace(/\\r\\n/g, '\r\n'));
						const subject = encodeURIComponent(data.subject);
						location.href = `mailto:${data.empfaengeradresse || ''}?subject=${subject}&body=${body}`;
					}
				});
			},
		},


		components: {
			ErcoCloak,
			'erco-header': ErcoLiveViewHeader,
		},
	};
</script>

<style lang="scss">

	.live-view {
		display: flex;
		flex-direction: column;
		height: 100vh;

		.header {

		}

		.frame {
			position: relative;
			flex: 1 0 auto;

			.frame-inner {
				height: 100%;
				width: 100%;
				position: absolute;

				.iframe {
					position: absolute;
					width: 100%;
					height: 100%;
					border: 0;
				}

				.not-found-info {
					width: 100%;
					height: 100%;
					text-align: center;
					position: absolute;

					> .info-text {
						margin: 35vh auto 0;
						max-width: 35%;

						> .state-name {
							font-weight: bold;
						}
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoLiveView.vue?10f6fb07